import type { ArtifactEntry } from "../stores/artifact-store"

import { useContentSidebarStore } from "@/stores/content-sidebar-store"

import { ARTIFACT_PANEL_ID } from "./artifact-panel-id"
import { ArtifactPanel } from "../components/artifact-panel"
import { useArtifactStore } from "../stores/artifact-store"

export function openArtifactInPanel(entry: ArtifactEntry): void {
  useArtifactStore.getState().setOpenArtifactId(entry.identifier)
  useContentSidebarStore.getState().openPanel({
    id: ARTIFACT_PANEL_ID,
    title: entry.title,
    content: <ArtifactPanel identifier={entry.identifier} />,
    focusable: true,
    closeable: true,
    resizable: true,
    isDirty: () => false,
    onClose: () => {
      const store = useArtifactStore.getState()
      if (store.openArtifactId === entry.identifier) {
        store.setOpenArtifactId(null)
      }
    },
  })
}
